export default "__VITE_ASSET__TutvILTC__"